import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";

const state = {
	hasData: false, // 是否请求了文档数据
	documentObj: {}, // 文档对象
};

const getters = {
	not_finish_document: state => {
		const documentObj = state.documentObj;
		return !documentObj.title
			|| (documentObj.paper && documentObj.paper.length < 1)
			|| (documentObj.summary && documentObj.summary.length < 1)
			|| (documentObj.ppt && documentObj.ppt.length < 1);
	}
};

const actions = {
	// 获取文档数据
	getDocument({commit, rootState}) {
		let api = API_MAP.DOCUMENT_INFO;
		let method = 'get';
		let payload = {};
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = (data) => {
			commit('setHasData', true);
			commit('setDocument', data);
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 提交
	submitLectureInfo({commit, state, rootState}, data) {
		let lecture_id = state.documentObj['lecture_id'];
		let api = lecture_id ? API_MAP.DOCUMENT_LECTURE_UPDATE : API_MAP.DOCUMENT_LECTURE_ADD;
		let method = 'json';
		let payload = data;
		if (lecture_id) {
			payload.id = lecture_id;
		}
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = (resData) => {
			commit('updateDocument', {lecture_id, data, resData});
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	}
};

const mutations = {
	// 更新请求状态
	setHasData(state, status) {
		state.hasData = status;
	},
	// 更新文档数据
	setDocument(state, data) {
		state.documentObj = data;
	},
	// 上传文件
	addFile(state, {file, type}) {
		state.documentObj[type].push(file);
	},
	// 删除文档
	deleteFile(state, {type, id}) {
		let currentPassportArr = state.documentObj[type];
		let resultArr = [];
		currentPassportArr.map(item => {
			if (item.id !== id) {
				resultArr.push(item);
			}
		});
		state.documentObj[type] = resultArr;
	},
	// 更新文档信息
	updateDocument(state, {lecture_id, data, resData}) {
		let result;
		let currentDocumentObj = state.documentObj;
		if (lecture_id) {
			// 如果原始有演讲id，代表此次为更新
			result = Object.assign({}, currentDocumentObj, data);
		} else {
			// 新增
			result = Object.assign({}, currentDocumentObj, data, {
				lecture_id: resData.id
			});
		}
		state.documentObj = result;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
